/**
 * Returns the percentage value inside of a limited range.
 * @param {number} min The start of the range
 * @param {number} max The end of the range
 * @param {number} value A value between `min` and `max`
 * @returns {number} A percentage value between 0 and 100
 */
const getPercentage = (min, max, value) => {
  const range = max - min;
  const valueInsideRange = value - min;
  const percentage = valueInsideRange * 100 / range;
  return percentage;
};

/**
 * Returns the remaining percentage of a given percentage value.
 * E.g.: if value == 80% then returns 20%
 * @param {number} value A percentage number between 0 and 100
 * @returns {number} A percentage value between 0 and 100
 */
const remainingPercentage = value => 100 - value;

/**
 * Returns true if both values are maxed out.
 * @param {number} value The initial value
 * @param {number} valueEnd The end value
 * @param {number} max The maximum value
 * @returns {boolean}
 */
const isMaxedOut = (value, valueEnd, max) => value === valueEnd && valueEnd === max;

export { getPercentage, isMaxedOut, remainingPercentage };
